import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { ScopeChangeRequestsContainer } from '@/features/admin/scope-change-requests/ScopeChangeRequests/ScopeChangeRequestsContainer'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export default observer(function AdminScopeChangeRequestsContainer() {
  const vm = useOutletContext<AdminViewModel>()
  return <ScopeChangeRequestsContainer vm={vm.scopeChangeRequestsVm} />
})
